/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Update client user request
 */
export interface UpdateClientUserRequest {
  subRole: UpdateClientUserRequest.SubRoleEnum;
  firstName?: string;
  lastName?: string;
  /**
   * Main account and/or subaccount IDs visible to user. Null keeps current visibility, empty list resets to default: all accounts are visible.
   */
  visibleAccountIds?: Array<number>;
}
export namespace UpdateClientUserRequest {
  export const SubRoleEnum = {
    ReadOnly: 'READ_ONLY',
    Trader: 'TRADER',
    TraderPro: 'TRADER_PRO',
  } as const;
  export type SubRoleEnum = (typeof SubRoleEnum)[keyof typeof SubRoleEnum];
}
